import Application from "../../Application";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import IndexNonHarmonizedReportPresenter, {
  IIndexNonHarmonizedReportPresenter
} from "../presenter/IndexNonHarmonizedReportPresenter";

export default class ShowIndexNonHarmonizedReportInteractor {
  private application: Application;
  private output?: IIndexNonHarmonizedReportPresenter;
  private getAllOrganisations: GetAllOrganisationsInteractor;

  constructor({ application, getAllOrganisations }: any) {
    this.application = application;
    this.getAllOrganisations = getAllOrganisations;
  }

  private async getOrganisations() {
    return this.getAllOrganisations.execute();
  }

  private async getReferenceLists() {
    return Promise.all([this.getOrganisations()]);
  }

  execute() {
    this.output = IndexNonHarmonizedReportPresenter({
      application: this.application,
      initialState: {
        mainOrganisationId: NaN,
        selectedCategoryId: NaN,
        organisationIds: [],
        organisations: [],
        organisationIndexCategories: [],
        dateIncluded: undefined,
        data: []
      }
    });
    this.getReferenceLists().then(([organisations]) => {
      this.output?.loadReferenceValues(organisations);
    });
    return this.output;
  }
}
